export var VERSION = '2.16.0';
//# sourceMappingURL=version.js.map